import { createUnleash } from 'shared/unleash/hook';
import type { FhhUnleashToggles } from '@/domain';

const { UnleashProvider, useUnleash } = createUnleash<FhhUnleashToggles>();

export { UnleashProvider, useUnleash };
